import React, { useState } from 'react'
import { calendarlogo, carouselSample, organisationlogo, profilecircle } from 'src/assets/images';
import './dicoverProgramCard.scss';
import { formatDate } from 'src/utils';
import { Button, Card, ConfirmModal, Typography } from 'src/components/common';
import { useNavigate } from 'react-router-dom';
import { useCopyToClipboard, useGetIdentity } from 'src/hooks';
import { Col, Row } from 'react-bootstrap';
import { openPopup } from 'src/store/common/common.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import Share from 'src/components/common/share/Share';
import { ShareIcon } from 'src/components/common/common.icons';

function truncateText(text: string, limit = 42) {
    const obj = {
        text: text.length > limit ? text.slice(0, limit) + "..." : text,
        isTruncate: text.length > limit
    }
    return obj
}
export default function ProgramCard({ program }: any) {
    const { getIdentities } = useGetIdentity();
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { copyToClipboard } = useCopyToClipboard();
    const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
    const { loggedInCompanyId, loggedInUserId } = getIdentities();

    const [imageLoaded, setImageLoaded] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);

    const userName = program?.user?.name || program?.company?.name || 'htraction';
    const userType = program?.user?.name ? 'User' : 'Company';
    const id = program?.userId || program?.companyId || '';

    function handleNavigate() {
        if (!id) {
            if (!process.env.REACT_APP_HTRACTION_ID) {
                return
            }
            const path = `/view-company?id=${process.env.REACT_APP_HTRACTION_ID}`
            navigate(path)
        } else {
            const path = userType === 'User' ? id === loggedInUserId ? '/my-profile?prev=/discover' : `/view-profile?id=${id}&prev=/discover` : id === loggedInCompanyId ? '/my-company?prev=/discover' : `/view-company?id=${id}&prev=/discover`
            navigate(path)
        }
    }
    function handelLogin() {
        navigate('/login?prev=/discover')
    }
    function handleShare() {
        if (!isAuthorized) {
            setShow(true)
            return
        }
        if (!program.link) {
            return
        }
        const link = program.link.startsWith("http") ? program.link : `https://${program?.link}`;
        copyToClipboard({ text: link });
        dispatch(
            openPopup({
                popupMessage: 'Link copied successfully!',
                popupType: 'success'
            })
        );
    }

    return (
        <>
            <ConfirmModal
                title=""
                description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
                    <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
                    <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
                </p>}
                openConfirmModal={show}
                onClose={() => setShow(false)}
                onSubmit={handelLogin}
                submitText="Sign in"
                type="confirm"
            />
            <div className="col-xl-6 col-lg-3 col-sm-4 ">
                <Card className="discoverMainCard">
                    {program?.banner && <img
                        src={program?.banner?.url}
                        alt={program?.programName || ''}
                        lang="lazy"
                        className='discoverMainCard__banner'
                        onError={() => setImageLoaded(false)}
                        onLoad={() => setImageLoaded(true)}
                        style={{ display: imageLoaded ? "block" : "none" }}
                    />}
                    {(!imageLoaded || !program?.banner) && <div className='discoverMainCard__fake-image'>
                        <span>No Banner</span>
                    </div>}
                    <div className="discoverMainCard__content">
                        <Typography
                            as="h3"
                            variant="body-2"
                            fontWeight="bold"
                            className="discoverMainCard__content__heading"
                        >
                            {program?.programName || '   '}
                        </Typography>
                        <Typography
                            as="h3"
                            variant="body-2"
                            fontWeight="semiBold"
                            className="discoverMainCard__content__labelling"
                        >
                            {program?.organisationName
                                ? <>
                                    <img src={organisationlogo} className='discoverMainCard__content__labelling__logo__org' alt="organisation-logo" /><span>{program?.organisationName}</span>
                                </>
                                : <br />}
                        </Typography>
                        <Typography
                            as="h3"
                            variant="body-2"
                            fontWeight="semiBold"
                            className="discoverMainCard__content__labelling"
                        >
                            {userName ? (
                                <>
                                    <img src={profilecircle} className='discoverMainCard__content__labelling__logo' alt="organisation-logo" /> Posted By: <span className={`discoverMainCard__content__labelling__user${(process.env.REACT_APP_HTRACTION_ID || id) ? '__redirect' : ''}`} onClick={handleNavigate}>
                                        {userName}
                                    </span>
                                </>
                            ) : (
                                <br />
                            )}
                        </Typography>
                        <Typography
                            as="h3"
                            variant="body-2"
                            fontWeight="semiBold"
                            className="discoverMainCard__content__labelling"
                        >
                            {program?.endDate
                                ? <>
                                    <img src={calendarlogo} className='discoverMainCard__content__labelling__logo__date' alt="organisation-logo" /><span>Last Apply: {formatDate({ dateString: program.endDate })}</span>
                                </>
                                : <br />}
                        </Typography>

                        <Typography
                            as="span"
                            variant="body-2"
                            fontWeight="semiBold"
                            className="discoverMainCard__content__para"
                        >
                            {program?.description ? <>
                                {truncateText(program.description, 40 * 3).text}
                                {truncateText(program.description, 40 * 3).isTruncate && <a
                                    href={program?.link && program.link.startsWith("http") ? program.link : `https://${program?.link}`}
                                    target={program?.link ? "_blank" : undefined}
                                    rel={program?.link ? "noopener noreferrer" : undefined}
                                    onClick={(e) => {
                                        if (!program?.link) e.preventDefault(); // Prevent redirection if link is missing
                                    }}
                                    className='discoverMainCard__content__para__see-more'>
                                    See more
                                </a>}
                            </> : <br />}
                        </Typography>
                        <div className='discoverMainCard__content__button-container'>
                            <a
                                href={program?.link && program.link.startsWith("http") ? program.link : `https://${program?.link}`}
                                target={program?.link ? "_blank" : undefined}
                                rel={program?.link ? "noopener noreferrer" : undefined}
                                className={`discoverMainCard__applyBtn${!program.link ? '__disabled' : ''}`}
                                onClick={(e) => {
                                    if (!program?.link) e.preventDefault(); // Prevent redirection if link is missing
                                }}
                            >
                                <Button
                                    className="discoverMainCard__applyBtn"
                                    variant="secondary"
                                >
                                    <Typography as="span" variant="body-2" fontWeight="semiBold">
                                        Apply
                                    </Typography>
                                </Button>
                            </a>

                            <Button
                                className="discoverMainCard__applyBtn__Share"
                                variant="secondary"
                                onClick={handleShare}
                            >
                                <Typography as="span" variant="body-2" fontWeight="semiBold">
                                    <ShareIcon color='#ff6239' /> Share
                                </Typography>
                            </Button>
                        </div>

                    </div>
                </Card >
            </div >
        </>
    )
}
